export default __webpack_public_path__ + "static/media/life.5841b610.png";